import React from 'react';
import { FaHandPaper, FaMousePointer } from 'react-icons/fa';
import { TooltipHtml } from '../tooltip/tooltip.Html';

export const BoardToolboxModeToggle = ({
  interactionMode = 'select',
  onInteractionModeChange,
  baseBtnClass = 'cursor-pointer transition hover:opacity-50 rounded flex items-center justify-center leading-none appearance-none bg-transparent border-0 p-0 m-0',
}) => (
  <>
    <TooltipHtml title='mode sélection'>
      <button
        type='button'
        aria-label='mode sélection'
        className={`${baseBtnClass} ${
          interactionMode === 'select' ? 'text-secondary' : 'text-contrast'
        }`}
        onClick={() => onInteractionModeChange?.('select')}
      >
        <FaMousePointer size={12} />
      </button>
    </TooltipHtml>
    <TooltipHtml title='mode déplacement'>
      <button
        type='button'
        aria-label='mode déplacement'
        className={`${baseBtnClass} ${
          interactionMode === 'pan' ? 'text-secondary' : 'text-contrast'
        }`}
        onClick={() => onInteractionModeChange?.('pan')}
      >
        <FaHandPaper size={12} />
      </button>
    </TooltipHtml>
  </>
);
